export const environment = {
  production: true,
  apiUrl: "https://site.vaunt.ro",
  baseApiPath: "v1/site",
  agency_uuid: "08da808d-803f-49eb-8c3a-9ec4e20f751d",
  sentry_public_dsn:
    "https://a23296e28abd4019bb288d7acef1ba8a@sentry.aesthetic-works.net/49",
  re_captcha_site_key: "6LcuzNcUAAAAAJqGjGlX89GcwIgkyEYGB6WbudNE",
  re_captcha_version: "v2_invisible",
  analytics_tracking_id: "UA-127889370-1",
  facebook_pixel_id: "283199082302669",
  release: "prod",
  router_link_has_locale: true,
  ads_tracking_id: "AW-768925269",
  ads_phone_conversion_label: null,
  default_locale: "ro",
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts